import type { LangCode } from '@learnforge/i18n';
import type { DemoKey } from './keys';
import { en } from './en';
import { zh } from './zh';
import { hi } from './hi';
import { es } from './es';
import { fr } from './fr';
import { ar } from './ar';
import { bn } from './bn';
import { pt } from './pt';
import { ru } from './ru';
import { ur } from './ur';
import { id } from './id';
import { de } from './de';
import { ja } from './ja';
import { mr } from './mr';
import { te } from './te';
import { tr } from './tr';
import { ta } from './ta';
import { vi } from './vi';
import { ro } from './ro';
import { tl } from './tl';
import { ko } from './ko';
import { fa } from './fa';
import { sw } from './sw';
import { it } from './it';
import { pa } from './pa';
import { gu } from './gu';
import { th } from './th';
import { pl } from './pl';
import { uk } from './uk';
import { nl } from './nl';

// Non-English locales are partial (keys missing fall back to English at runtime).
// The cast satisfies createI18n's type, which marks the whole language as optional
// but treats present entries as full records. The runtime handles missing keys safely.
export const locales: Partial<Record<LangCode, Record<DemoKey, string>>> & {
  en: Record<DemoKey, string>;
} = {
  en,
  zh: zh as Record<DemoKey, string>,
  hi: hi as Record<DemoKey, string>,
  es: es as Record<DemoKey, string>,
  fr: fr as Record<DemoKey, string>,
  ar: ar as Record<DemoKey, string>,
  bn: bn as Record<DemoKey, string>,
  pt: pt as Record<DemoKey, string>,
  ru: ru as Record<DemoKey, string>,
  ur: ur as Record<DemoKey, string>,
  id: id as Record<DemoKey, string>,
  de: de as Record<DemoKey, string>,
  ja: ja as Record<DemoKey, string>,
  mr: mr as Record<DemoKey, string>,
  te: te as Record<DemoKey, string>,
  tr: tr as Record<DemoKey, string>,
  ta: ta as Record<DemoKey, string>,
  vi: vi as Record<DemoKey, string>,
  ro: ro as Record<DemoKey, string>,
  tl: tl as Record<DemoKey, string>,
  ko: ko as Record<DemoKey, string>,
  fa: fa as Record<DemoKey, string>,
  sw: sw as Record<DemoKey, string>,
  it: it as Record<DemoKey, string>,
  pa: pa as Record<DemoKey, string>,
  gu: gu as Record<DemoKey, string>,
  th: th as Record<DemoKey, string>,
  pl: pl as Record<DemoKey, string>,
  uk: uk as Record<DemoKey, string>,
  nl: nl as Record<DemoKey, string>,
};

export type { DemoKey } from './keys';
